/* tslint:disable */
/* eslint-disable */
/**
 * cafect
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AdministratorLoginRequest
 */
export interface AdministratorLoginRequest {
    /**
     * 
     * @type {UserLoginRequestUser}
     * @memberof AdministratorLoginRequest
     */
    'administrator': UserLoginRequestUser;
}
/**
 * 
 * @export
 * @interface Budget
 */
export interface Budget {
    /**
     * 
     * @type {number}
     * @memberof Budget
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Budget
     */
    'timeframe': string;
    /**
     * 
     * @type {number}
     * @memberof Budget
     */
    'lower': number;
    /**
     * 
     * @type {number}
     * @memberof Budget
     */
    'upper': number;
}
/**
 * 
 * @export
 * @interface Budgets
 */
export interface Budgets {
    /**
     * 
     * @type {string}
     * @memberof Budgets
     */
    'timeframe': string;
    /**
     * 
     * @type {number}
     * @memberof Budgets
     */
    'lower': number;
    /**
     * 
     * @type {number}
     * @memberof Budgets
     */
    'upper': number;
}
/**
 * 
 * @export
 * @interface CreateAdministratorShopRequest
 */
export interface CreateAdministratorShopRequest {
    /**
     * 
     * @type {CreateAdministratorShopRequestShop}
     * @memberof CreateAdministratorShopRequest
     */
    'shop': CreateAdministratorShopRequestShop;
}
/**
 * 
 * @export
 * @interface CreateAdministratorShopRequestShop
 */
export interface CreateAdministratorShopRequestShop {
    /**
     * 
     * @type {string}
     * @memberof CreateAdministratorShopRequestShop
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAdministratorShopRequestShop
     */
    'nameKana': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAdministratorShopRequestShop
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAdministratorShopRequestShop
     */
    'tel'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAdministratorShopRequestShop
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAdministratorShopRequestShop
     */
    'nearestStation'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateAdministratorShopRequestShop
     */
    'numberOfSeats'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateAdministratorShopRequestShop
     */
    'paymentMethodIds': Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateAdministratorShopRequestShop
     */
    'featureIds'?: Array<number>;
    /**
     * 
     * @type {Array<CreateDraftShopRequestShopDraftBudgetsAttributesInner>}
     * @memberof CreateAdministratorShopRequestShop
     */
    'budgetsAttributes': Array<CreateDraftShopRequestShopDraftBudgetsAttributesInner>;
    /**
     * 
     * @type {Array<CreateShopRequestShopOpeningHoursAttributesInner>}
     * @memberof CreateAdministratorShopRequestShop
     */
    'openingHoursAttributes': Array<CreateShopRequestShopOpeningHoursAttributesInner>;
    /**
     * 
     * @type {Array<Image>}
     * @memberof CreateAdministratorShopRequestShop
     */
    'images'?: Array<Image> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAdministratorShopRequestShop
     */
    'homepage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAdministratorShopRequestShop
     */
    'googleMapUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAdministratorShopRequestShop
     */
    'googleMapIframe'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAdministratorShopRequestShop
     */
    'note'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateAdministratorShopRequestShop
     */
    'isPublic'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateDraftShopRequest
 */
export interface CreateDraftShopRequest {
    /**
     * 
     * @type {CreateDraftShopRequestShop}
     * @memberof CreateDraftShopRequest
     */
    'shop': CreateDraftShopRequestShop;
}
/**
 * 
 * @export
 * @interface CreateDraftShopRequestShop
 */
export interface CreateDraftShopRequestShop {
    /**
     * 
     * @type {string}
     * @memberof CreateDraftShopRequestShop
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDraftShopRequestShop
     */
    'nameKana': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDraftShopRequestShop
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDraftShopRequestShop
     */
    'tel'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDraftShopRequestShop
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDraftShopRequestShop
     */
    'nearestStation'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateDraftShopRequestShop
     */
    'numberOfSeats'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateDraftShopRequestShop
     */
    'paymentMethodIds': Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateDraftShopRequestShop
     */
    'featureIds'?: Array<number>;
    /**
     * 
     * @type {Array<CreateDraftShopRequestShopDraftBudgetsAttributesInner>}
     * @memberof CreateDraftShopRequestShop
     */
    'draftBudgetsAttributes': Array<CreateDraftShopRequestShopDraftBudgetsAttributesInner>;
    /**
     * 
     * @type {Array<CreateDraftShopRequestShopDraftOpeningHoursAttributesInner>}
     * @memberof CreateDraftShopRequestShop
     */
    'draftOpeningHoursAttributes': Array<CreateDraftShopRequestShopDraftOpeningHoursAttributesInner>;
    /**
     * 
     * @type {number}
     * @memberof CreateDraftShopRequestShop
     */
    'requestUserId': number | null;
    /**
     * 
     * @type {Array<Image>}
     * @memberof CreateDraftShopRequestShop
     */
    'images'?: Array<Image> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDraftShopRequestShop
     */
    'homepage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDraftShopRequestShop
     */
    'googleMapUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDraftShopRequestShop
     */
    'googleMapIframe'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDraftShopRequestShop
     */
    'note'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateDraftShopRequestShop
     */
    'shopId'?: number | null;
}
/**
 * 
 * @export
 * @interface CreateDraftShopRequestShopDraftBudgetsAttributesInner
 */
export interface CreateDraftShopRequestShopDraftBudgetsAttributesInner {
    /**
     * 
     * @type {number}
     * @memberof CreateDraftShopRequestShopDraftBudgetsAttributesInner
     */
    'timeframe': number;
    /**
     * 
     * @type {number}
     * @memberof CreateDraftShopRequestShopDraftBudgetsAttributesInner
     */
    'lower': number;
    /**
     * 
     * @type {number}
     * @memberof CreateDraftShopRequestShopDraftBudgetsAttributesInner
     */
    'upper': number;
}
/**
 * 
 * @export
 * @interface CreateDraftShopRequestShopDraftOpeningHoursAttributesInner
 */
export interface CreateDraftShopRequestShopDraftOpeningHoursAttributesInner {
    /**
     * 
     * @type {number}
     * @memberof CreateDraftShopRequestShopDraftOpeningHoursAttributesInner
     */
    'dayOfWeek': number;
    /**
     * 
     * @type {string}
     * @memberof CreateDraftShopRequestShopDraftOpeningHoursAttributesInner
     */
    'peningTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDraftShopRequestShopDraftOpeningHoursAttributesInner
     */
    'closingTime': string;
}
/**
 * 
 * @export
 * @interface CreateOwnerRequest
 */
export interface CreateOwnerRequest {
    /**
     * 
     * @type {CreateOwnerRequestOwner}
     * @memberof CreateOwnerRequest
     */
    'owner': CreateOwnerRequestOwner;
}
/**
 * 
 * @export
 * @interface CreateOwnerRequestOwner
 */
export interface CreateOwnerRequestOwner {
    /**
     * 
     * @type {string}
     * @memberof CreateOwnerRequestOwner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOwnerRequestOwner
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOwnerRequestOwner
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOwnerRequestOwner
     */
    'passwordConfirmation'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOwnerRequestOwner
     */
    'birthday': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOwnerRequestOwner
     */
    'password_confirmation'?: string;
}
/**
 * 
 * @export
 * @interface CreateShopRequest
 */
export interface CreateShopRequest {
    /**
     * 
     * @type {CreateShopRequestShop}
     * @memberof CreateShopRequest
     */
    'shop': CreateShopRequestShop;
}
/**
 * 
 * @export
 * @interface CreateShopRequestShop
 */
export interface CreateShopRequestShop {
    /**
     * 
     * @type {string}
     * @memberof CreateShopRequestShop
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateShopRequestShop
     */
    'nameKana': string;
    /**
     * 
     * @type {string}
     * @memberof CreateShopRequestShop
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof CreateShopRequestShop
     */
    'tel'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateShopRequestShop
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateShopRequestShop
     */
    'nearestStation'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateShopRequestShop
     */
    'numberOfSeats'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateShopRequestShop
     */
    'paymentMethodIds': Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateShopRequestShop
     */
    'featureIds'?: Array<number>;
    /**
     * 
     * @type {Array<CreateDraftShopRequestShopDraftBudgetsAttributesInner>}
     * @memberof CreateShopRequestShop
     */
    'budgetsAttributes': Array<CreateDraftShopRequestShopDraftBudgetsAttributesInner>;
    /**
     * 
     * @type {Array<CreateShopRequestShopOpeningHoursAttributesInner>}
     * @memberof CreateShopRequestShop
     */
    'openingHoursAttributes': Array<CreateShopRequestShopOpeningHoursAttributesInner>;
    /**
     * 
     * @type {number}
     * @memberof CreateShopRequestShop
     */
    'requestUserId': number | null;
    /**
     * 
     * @type {Array<Image>}
     * @memberof CreateShopRequestShop
     */
    'images'?: Array<Image> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateShopRequestShop
     */
    'homepage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateShopRequestShop
     */
    'googleMapUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateShopRequestShop
     */
    'googleMapIframe'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateShopRequestShop
     */
    'note'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateShopRequestShopOpeningHoursAttributesInner
 */
export interface CreateShopRequestShopOpeningHoursAttributesInner {
    /**
     * 
     * @type {number}
     * @memberof CreateShopRequestShopOpeningHoursAttributesInner
     */
    'dayOfWeek': number;
    /**
     * 
     * @type {string}
     * @memberof CreateShopRequestShopOpeningHoursAttributesInner
     */
    'openingTime': string;
    /**
     * 
     * @type {string}
     * @memberof CreateShopRequestShopOpeningHoursAttributesInner
     */
    'closingTime': string;
}
/**
 * 
 * @export
 * @interface CreateUser200Response
 */
export interface CreateUser200Response {
    /**
     * 
     * @type {string}
     * @memberof CreateUser200Response
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface CreateUserRequest
 */
export interface CreateUserRequest {
    /**
     * 
     * @type {CreateUserRequestUser}
     * @memberof CreateUserRequest
     */
    'user': CreateUserRequestUser;
}
/**
 * 
 * @export
 * @interface CreateUserRequestUser
 */
export interface CreateUserRequestUser {
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequestUser
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequestUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequestUser
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequestUser
     */
    'passwordConfirmation'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequestUser
     */
    'password_confirmation'?: string;
}
/**
 * 
 * @export
 * @interface DraftBudgets
 */
export interface DraftBudgets {
    /**
     * 
     * @type {string}
     * @memberof DraftBudgets
     */
    'timeframe': string;
    /**
     * 
     * @type {number}
     * @memberof DraftBudgets
     */
    'lower': number;
    /**
     * 
     * @type {number}
     * @memberof DraftBudgets
     */
    'upper': number;
}
/**
 * 
 * @export
 * @interface DraftOpeningHours
 */
export interface DraftOpeningHours {
    /**
     * 
     * @type {string}
     * @memberof DraftOpeningHours
     */
    'dayOfWeek': string;
    /**
     * 
     * @type {string}
     * @memberof DraftOpeningHours
     */
    'openingTime': string;
    /**
     * 
     * @type {string}
     * @memberof DraftOpeningHours
     */
    'closingTime': string;
}
/**
 * 
 * @export
 * @interface Feature
 */
export interface Feature {
    /**
     * 
     * @type {number}
     * @memberof Feature
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Feature
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface Features
 */
export interface Features {
    /**
     * 
     * @type {number}
     * @memberof Features
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Features
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetAdministratorDraftShop200Response
 */
export interface GetAdministratorDraftShop200Response {
    /**
     * 
     * @type {number}
     * @memberof GetAdministratorDraftShop200Response
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GetAdministratorDraftShop200Response
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetAdministratorDraftShop200Response
     */
    'nameKana': string;
    /**
     * 
     * @type {string}
     * @memberof GetAdministratorDraftShop200Response
     */
    'address': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetAdministratorDraftShop200Response
     */
    'official': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetAdministratorDraftShop200Response
     */
    'tel': string;
    /**
     * 
     * @type {string}
     * @memberof GetAdministratorDraftShop200Response
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof GetAdministratorDraftShop200Response
     */
    'nearestStation': string;
    /**
     * 
     * @type {number}
     * @memberof GetAdministratorDraftShop200Response
     */
    'numberOfSeats': number;
    /**
     * 
     * @type {number}
     * @memberof GetAdministratorDraftShop200Response
     */
    'requestUserId': number;
    /**
     * 
     * @type {Array<Image>}
     * @memberof GetAdministratorDraftShop200Response
     */
    'images': Array<Image> | null;
    /**
     * 
     * @type {string}
     * @memberof GetAdministratorDraftShop200Response
     */
    'homepage': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAdministratorDraftShop200Response
     */
    'googleMapUrl': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAdministratorDraftShop200Response
     */
    'googleMapIframe': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAdministratorDraftShop200Response
     */
    'note': string | null;
    /**
     * 
     * @type {object}
     * @memberof GetAdministratorDraftShop200Response
     */
    'shopId': object | null;
    /**
     * 
     * @type {Array<GetCafeNotes200ResponseInnerShopPaymentMethodsInner>}
     * @memberof GetAdministratorDraftShop200Response
     */
    'paymentMethods': Array<GetCafeNotes200ResponseInnerShopPaymentMethodsInner>;
    /**
     * 
     * @type {Array<GetShop200ResponseBudgetsInner>}
     * @memberof GetAdministratorDraftShop200Response
     */
    'draftBudgets': Array<GetShop200ResponseBudgetsInner>;
    /**
     * 
     * @type {Array<GetCafeNotes200ResponseInnerShopPaymentMethodsInner>}
     * @memberof GetAdministratorDraftShop200Response
     */
    'features': Array<GetCafeNotes200ResponseInnerShopPaymentMethodsInner>;
    /**
     * 
     * @type {Array<GetAdministratorDraftShop200ResponseDraftOpeningHoursInner>}
     * @memberof GetAdministratorDraftShop200Response
     */
    'draftOpeningHours': Array<GetAdministratorDraftShop200ResponseDraftOpeningHoursInner>;
    /**
     * 
     * @type {GetAdministratorDraftShops200ResponseInnerUser}
     * @memberof GetAdministratorDraftShop200Response
     */
    'user': GetAdministratorDraftShops200ResponseInnerUser;
    /**
     * 
     * @type {boolean}
     * @memberof GetAdministratorDraftShop200Response
     */
    'approvalFlag': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetAdministratorDraftShop200Response
     */
    'approvalStatus': GetAdministratorDraftShop200ResponseApprovalStatusEnum;
}

export const GetAdministratorDraftShop200ResponseApprovalStatusEnum = {
    Unapproved: 'unapproved',
    Approved: 'approved',
    Rejected: 'rejected'
} as const;

export type GetAdministratorDraftShop200ResponseApprovalStatusEnum = typeof GetAdministratorDraftShop200ResponseApprovalStatusEnum[keyof typeof GetAdministratorDraftShop200ResponseApprovalStatusEnum];

/**
 * 
 * @export
 * @interface GetAdministratorDraftShop200ResponseDraftOpeningHoursInner
 */
export interface GetAdministratorDraftShop200ResponseDraftOpeningHoursInner {
    /**
     * 
     * @type {number}
     * @memberof GetAdministratorDraftShop200ResponseDraftOpeningHoursInner
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GetAdministratorDraftShop200ResponseDraftOpeningHoursInner
     */
    'dayOfWeek': string;
    /**
     * 
     * @type {string}
     * @memberof GetAdministratorDraftShop200ResponseDraftOpeningHoursInner
     */
    'openingTime': string;
    /**
     * 
     * @type {string}
     * @memberof GetAdministratorDraftShop200ResponseDraftOpeningHoursInner
     */
    'closingTime': string;
}
/**
 * 
 * @export
 * @interface GetAdministratorDraftShops200ResponseInner
 */
export interface GetAdministratorDraftShops200ResponseInner {
    /**
     * 
     * @type {number}
     * @memberof GetAdministratorDraftShops200ResponseInner
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GetAdministratorDraftShops200ResponseInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetAdministratorDraftShops200ResponseInner
     */
    'nameKana': string;
    /**
     * 
     * @type {string}
     * @memberof GetAdministratorDraftShops200ResponseInner
     */
    'address': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetAdministratorDraftShops200ResponseInner
     */
    'official': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetAdministratorDraftShops200ResponseInner
     */
    'tel': string;
    /**
     * 
     * @type {string}
     * @memberof GetAdministratorDraftShops200ResponseInner
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof GetAdministratorDraftShops200ResponseInner
     */
    'nearestStation': string;
    /**
     * 
     * @type {number}
     * @memberof GetAdministratorDraftShops200ResponseInner
     */
    'numberOfSeats': number;
    /**
     * 
     * @type {number}
     * @memberof GetAdministratorDraftShops200ResponseInner
     */
    'requestUserId': number | null;
    /**
     * 
     * @type {Array<PaymentMethods>}
     * @memberof GetAdministratorDraftShops200ResponseInner
     */
    'paymentMethods': Array<PaymentMethods>;
    /**
     * 
     * @type {Array<DraftBudgets>}
     * @memberof GetAdministratorDraftShops200ResponseInner
     */
    'draftBudgets': Array<DraftBudgets>;
    /**
     * 
     * @type {Array<DraftOpeningHours>}
     * @memberof GetAdministratorDraftShops200ResponseInner
     */
    'draftOpeningHours': Array<DraftOpeningHours>;
    /**
     * 
     * @type {Array<Feature>}
     * @memberof GetAdministratorDraftShops200ResponseInner
     */
    'features': Array<Feature>;
    /**
     * 
     * @type {GetAdministratorDraftShops200ResponseInnerUser}
     * @memberof GetAdministratorDraftShops200ResponseInner
     */
    'user'?: GetAdministratorDraftShops200ResponseInnerUser;
    /**
     * 
     * @type {object}
     * @memberof GetAdministratorDraftShops200ResponseInner
     */
    'shopId': object | null;
    /**
     * 
     * @type {Array<Image>}
     * @memberof GetAdministratorDraftShops200ResponseInner
     */
    'images'?: Array<Image> | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetAdministratorDraftShops200ResponseInner
     */
    'approvalFlag': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetAdministratorDraftShops200ResponseInner
     */
    'approvalStatus': GetAdministratorDraftShops200ResponseInnerApprovalStatusEnum;
}

export const GetAdministratorDraftShops200ResponseInnerApprovalStatusEnum = {
    Unapproved: 'unapproved',
    Approved: 'approved',
    Rejected: 'rejected'
} as const;

export type GetAdministratorDraftShops200ResponseInnerApprovalStatusEnum = typeof GetAdministratorDraftShops200ResponseInnerApprovalStatusEnum[keyof typeof GetAdministratorDraftShops200ResponseInnerApprovalStatusEnum];

/**
 * 
 * @export
 * @interface GetAdministratorDraftShops200ResponseInnerUser
 */
export interface GetAdministratorDraftShops200ResponseInnerUser {
    /**
     * 
     * @type {string}
     * @memberof GetAdministratorDraftShops200ResponseInnerUser
     */
    'username': string;
}
/**
 * 
 * @export
 * @interface GetAdministratorSession200Response
 */
export interface GetAdministratorSession200Response {
    /**
     * 
     * @type {number}
     * @memberof GetAdministratorSession200Response
     */
    'administratorId': number;
}
/**
 * 
 * @export
 * @interface GetAdministratorShop200Response
 */
export interface GetAdministratorShop200Response {
    /**
     * 
     * @type {number}
     * @memberof GetAdministratorShop200Response
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GetAdministratorShop200Response
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetAdministratorShop200Response
     */
    'nameKana': string;
    /**
     * 
     * @type {string}
     * @memberof GetAdministratorShop200Response
     */
    'address': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetAdministratorShop200Response
     */
    'official': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetAdministratorShop200Response
     */
    'tel': string;
    /**
     * 
     * @type {string}
     * @memberof GetAdministratorShop200Response
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof GetAdministratorShop200Response
     */
    'nearestStation': string;
    /**
     * 
     * @type {number}
     * @memberof GetAdministratorShop200Response
     */
    'numberOfSeats': number;
    /**
     * 
     * @type {boolean}
     * @memberof GetAdministratorShop200Response
     */
    'isPublic': boolean;
    /**
     * 
     * @type {number}
     * @memberof GetAdministratorShop200Response
     */
    'requestUserId'?: number | null;
    /**
     * 
     * @type {Array<Image>}
     * @memberof GetAdministratorShop200Response
     */
    'images'?: Array<Image> | null;
    /**
     * 
     * @type {string}
     * @memberof GetAdministratorShop200Response
     */
    'homepage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAdministratorShop200Response
     */
    'googleMapUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAdministratorShop200Response
     */
    'googleMapIframe'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAdministratorShop200Response
     */
    'note'?: string | null;
    /**
     * 
     * @type {Array<PaymentMethod>}
     * @memberof GetAdministratorShop200Response
     */
    'paymentMethods': Array<PaymentMethod>;
    /**
     * 
     * @type {Array<Feature>}
     * @memberof GetAdministratorShop200Response
     */
    'features': Array<Feature>;
    /**
     * 
     * @type {Array<Budget>}
     * @memberof GetAdministratorShop200Response
     */
    'budgets': Array<Budget>;
    /**
     * 
     * @type {Array<OpeningHour>}
     * @memberof GetAdministratorShop200Response
     */
    'openingHours': Array<OpeningHour>;
}
/**
 * 
 * @export
 * @interface GetAdministratorShops200ResponseInner
 */
export interface GetAdministratorShops200ResponseInner {
    /**
     * 
     * @type {number}
     * @memberof GetAdministratorShops200ResponseInner
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GetAdministratorShops200ResponseInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetAdministratorShops200ResponseInner
     */
    'nameKana': string;
    /**
     * 
     * @type {string}
     * @memberof GetAdministratorShops200ResponseInner
     */
    'address': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetAdministratorShops200ResponseInner
     */
    'official': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetAdministratorShops200ResponseInner
     */
    'tel': string;
    /**
     * 
     * @type {string}
     * @memberof GetAdministratorShops200ResponseInner
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof GetAdministratorShops200ResponseInner
     */
    'nearestStation': string;
    /**
     * 
     * @type {number}
     * @memberof GetAdministratorShops200ResponseInner
     */
    'numberOfSeats': number;
    /**
     * 
     * @type {boolean}
     * @memberof GetAdministratorShops200ResponseInner
     */
    'isPublic': boolean;
    /**
     * 
     * @type {number}
     * @memberof GetAdministratorShops200ResponseInner
     */
    'requestUserId': number | null;
    /**
     * 
     * @type {Array<PaymentMethod>}
     * @memberof GetAdministratorShops200ResponseInner
     */
    'paymentMethods': Array<PaymentMethod>;
    /**
     * 
     * @type {Array<Budget>}
     * @memberof GetAdministratorShops200ResponseInner
     */
    'budgets': Array<Budget>;
    /**
     * 
     * @type {Array<OpeningHour>}
     * @memberof GetAdministratorShops200ResponseInner
     */
    'openingHours': Array<OpeningHour>;
    /**
     * 
     * @type {Array<Feature>}
     * @memberof GetAdministratorShops200ResponseInner
     */
    'features': Array<Feature>;
}
/**
 * 
 * @export
 * @interface GetAdministratorsUsers200ResponseInner
 */
export interface GetAdministratorsUsers200ResponseInner {
    /**
     * 
     * @type {number}
     * @memberof GetAdministratorsUsers200ResponseInner
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GetAdministratorsUsers200ResponseInner
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof GetAdministratorsUsers200ResponseInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetAdministratorsUsers200ResponseInner
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetAdministratorsUsers200ResponseInner
     */
    'birthday': string;
    /**
     * 
     * @type {GetProfile200ResponseImage}
     * @memberof GetAdministratorsUsers200ResponseInner
     */
    'image': GetProfile200ResponseImage | null;
    /**
     * 
     * @type {Array<object>}
     * @memberof GetAdministratorsUsers200ResponseInner
     */
    'badges': Array<object>;
}
/**
 * 
 * @export
 * @interface GetCafeNote200Response
 */
export interface GetCafeNote200Response {
    /**
     * 
     * @type {number}
     * @memberof GetCafeNote200Response
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GetCafeNote200Response
     */
    'title': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetCafeNote200Response
     */
    'visitingDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetCafeNote200Response
     */
    'body': string;
    /**
     * 
     * @type {number}
     * @memberof GetCafeNote200Response
     */
    'shopId': number;
    /**
     * 
     * @type {string}
     * @memberof GetCafeNote200Response
     */
    'shopName'?: string;
    /**
     * 
     * @type {Array<Image>}
     * @memberof GetCafeNote200Response
     */
    'images'?: Array<Image> | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetCafeNote200Response
     */
    'isPublic': boolean;
    /**
     * 
     * @type {GetCafeNote200ResponseShop}
     * @memberof GetCafeNote200Response
     */
    'shop'?: GetCafeNote200ResponseShop;
}
/**
 * 
 * @export
 * @interface GetCafeNote200ResponseShop
 */
export interface GetCafeNote200ResponseShop {
    /**
     * 
     * @type {number}
     * @memberof GetCafeNote200ResponseShop
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GetCafeNote200ResponseShop
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCafeNote200ResponseShop
     */
    'nameKana': string;
    /**
     * 
     * @type {string}
     * @memberof GetCafeNote200ResponseShop
     */
    'address': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCafeNote200ResponseShop
     */
    'official': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetCafeNote200ResponseShop
     */
    'tel': string;
    /**
     * 
     * @type {string}
     * @memberof GetCafeNote200ResponseShop
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof GetCafeNote200ResponseShop
     */
    'nearestStation': string;
    /**
     * 
     * @type {number}
     * @memberof GetCafeNote200ResponseShop
     */
    'numberOfSeats': number;
    /**
     * 
     * @type {boolean}
     * @memberof GetCafeNote200ResponseShop
     */
    'isPublic': boolean;
    /**
     * 
     * @type {object}
     * @memberof GetCafeNote200ResponseShop
     */
    'requestUserId': object | null;
}
/**
 * 
 * @export
 * @interface GetCafeNotes200ResponseInner
 */
export interface GetCafeNotes200ResponseInner {
    /**
     * 
     * @type {number}
     * @memberof GetCafeNotes200ResponseInner
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GetCafeNotes200ResponseInner
     */
    'title': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetCafeNotes200ResponseInner
     */
    'visitingDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetCafeNotes200ResponseInner
     */
    'body': string;
    /**
     * 
     * @type {number}
     * @memberof GetCafeNotes200ResponseInner
     */
    'shopId': number;
    /**
     * 
     * @type {string}
     * @memberof GetCafeNotes200ResponseInner
     */
    'shopName': string;
    /**
     * 
     * @type {Array<Image>}
     * @memberof GetCafeNotes200ResponseInner
     */
    'images': Array<Image>;
    /**
     * 
     * @type {boolean}
     * @memberof GetCafeNotes200ResponseInner
     */
    'isPublic': boolean;
    /**
     * 
     * @type {GetCafeNotes200ResponseInnerShop}
     * @memberof GetCafeNotes200ResponseInner
     */
    'shop': GetCafeNotes200ResponseInnerShop;
}
/**
 * 
 * @export
 * @interface GetCafeNotes200ResponseInnerShop
 */
export interface GetCafeNotes200ResponseInnerShop {
    /**
     * 
     * @type {number}
     * @memberof GetCafeNotes200ResponseInnerShop
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GetCafeNotes200ResponseInnerShop
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCafeNotes200ResponseInnerShop
     */
    'nameKana': string;
    /**
     * 
     * @type {string}
     * @memberof GetCafeNotes200ResponseInnerShop
     */
    'address': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCafeNotes200ResponseInnerShop
     */
    'official': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetCafeNotes200ResponseInnerShop
     */
    'tel': string;
    /**
     * 
     * @type {string}
     * @memberof GetCafeNotes200ResponseInnerShop
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof GetCafeNotes200ResponseInnerShop
     */
    'nearestStation': string;
    /**
     * 
     * @type {number}
     * @memberof GetCafeNotes200ResponseInnerShop
     */
    'numberOfSeats': number;
    /**
     * 
     * @type {boolean}
     * @memberof GetCafeNotes200ResponseInnerShop
     */
    'isPublic': boolean;
    /**
     * 
     * @type {object}
     * @memberof GetCafeNotes200ResponseInnerShop
     */
    'requestUserId': object | null;
    /**
     * 
     * @type {Array<GetCafeNotes200ResponseInnerShopPaymentMethodsInner>}
     * @memberof GetCafeNotes200ResponseInnerShop
     */
    'paymentMethods': Array<GetCafeNotes200ResponseInnerShopPaymentMethodsInner>;
    /**
     * 
     * @type {Array<GetCafeNotes200ResponseInnerShopBudgetsInner>}
     * @memberof GetCafeNotes200ResponseInnerShop
     */
    'budgets': Array<GetCafeNotes200ResponseInnerShopBudgetsInner>;
    /**
     * 
     * @type {Array<GetCafeNotes200ResponseInnerShopOpeningHoursInner>}
     * @memberof GetCafeNotes200ResponseInnerShop
     */
    'openingHours': Array<GetCafeNotes200ResponseInnerShopOpeningHoursInner>;
}
/**
 * 
 * @export
 * @interface GetCafeNotes200ResponseInnerShopBudgetsInner
 */
export interface GetCafeNotes200ResponseInnerShopBudgetsInner {
    /**
     * 
     * @type {string}
     * @memberof GetCafeNotes200ResponseInnerShopBudgetsInner
     */
    'timeframe': string;
    /**
     * 
     * @type {number}
     * @memberof GetCafeNotes200ResponseInnerShopBudgetsInner
     */
    'lower': number;
    /**
     * 
     * @type {number}
     * @memberof GetCafeNotes200ResponseInnerShopBudgetsInner
     */
    'upper': number;
}
/**
 * 
 * @export
 * @interface GetCafeNotes200ResponseInnerShopOpeningHoursInner
 */
export interface GetCafeNotes200ResponseInnerShopOpeningHoursInner {
    /**
     * 
     * @type {string}
     * @memberof GetCafeNotes200ResponseInnerShopOpeningHoursInner
     */
    'dayOfWeek': string;
    /**
     * 
     * @type {string}
     * @memberof GetCafeNotes200ResponseInnerShopOpeningHoursInner
     */
    'openingTime': string;
    /**
     * 
     * @type {string}
     * @memberof GetCafeNotes200ResponseInnerShopOpeningHoursInner
     */
    'closingTime': string;
}
/**
 * 
 * @export
 * @interface GetCafeNotes200ResponseInnerShopPaymentMethodsInner
 */
export interface GetCafeNotes200ResponseInnerShopPaymentMethodsInner {
    /**
     * 
     * @type {number}
     * @memberof GetCafeNotes200ResponseInnerShopPaymentMethodsInner
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GetCafeNotes200ResponseInnerShopPaymentMethodsInner
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetProfile200Response
 */
export interface GetProfile200Response {
    /**
     * 
     * @type {string}
     * @memberof GetProfile200Response
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof GetProfile200Response
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetProfile200Response
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetProfile200Response
     */
    'birthday': string;
    /**
     * 
     * @type {GetProfile200ResponseImage}
     * @memberof GetProfile200Response
     */
    'image'?: GetProfile200ResponseImage | null;
    /**
     * 
     * @type {Array<GetProfile200ResponseBadgesInner>}
     * @memberof GetProfile200Response
     */
    'badges'?: Array<GetProfile200ResponseBadgesInner>;
}
/**
 * 
 * @export
 * @interface GetProfile200ResponseBadgesInner
 */
export interface GetProfile200ResponseBadgesInner {
    /**
     * 
     * @type {string}
     * @memberof GetProfile200ResponseBadgesInner
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetProfile200ResponseBadgesInner
     */
    'type'?: string;
}
/**
 * 
 * @export
 * @interface GetProfile200ResponseImage
 */
export interface GetProfile200ResponseImage {
    /**
     * 
     * @type {number}
     * @memberof GetProfile200ResponseImage
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetProfile200ResponseImage
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface GetPublicCafeNote200Response
 */
export interface GetPublicCafeNote200Response {
    /**
     * 
     * @type {number}
     * @memberof GetPublicCafeNote200Response
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GetPublicCafeNote200Response
     */
    'title': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPublicCafeNote200Response
     */
    'visitingDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetPublicCafeNote200Response
     */
    'body': string;
    /**
     * 
     * @type {number}
     * @memberof GetPublicCafeNote200Response
     */
    'shopId': number;
    /**
     * 
     * @type {string}
     * @memberof GetPublicCafeNote200Response
     */
    'shopName'?: string;
    /**
     * 
     * @type {Array<Image>}
     * @memberof GetPublicCafeNote200Response
     */
    'images'?: Array<Image> | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetPublicCafeNote200Response
     */
    'isPublic': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetPublicCafeNote200Response
     */
    'username': string;
    /**
     * 
     * @type {GetCafeNote200ResponseShop}
     * @memberof GetPublicCafeNote200Response
     */
    'shop'?: GetCafeNote200ResponseShop;
}
/**
 * 
 * @export
 * @interface GetPublicProfile200Response
 */
export interface GetPublicProfile200Response {
    /**
     * 
     * @type {string}
     * @memberof GetPublicProfile200Response
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof GetPublicProfile200Response
     */
    'imageUrl': string | null;
    /**
     * 
     * @type {number}
     * @memberof GetPublicProfile200Response
     */
    'countPublicCafeNotes': number;
    /**
     * 
     * @type {number}
     * @memberof GetPublicProfile200Response
     */
    'countApprovedRequestShops': number;
    /**
     * 
     * @type {Array<GetPublicProfile200ResponseBadgesInner>}
     * @memberof GetPublicProfile200Response
     */
    'badges': Array<GetPublicProfile200ResponseBadgesInner>;
}
/**
 * 
 * @export
 * @interface GetPublicProfile200ResponseBadgesInner
 */
export interface GetPublicProfile200ResponseBadgesInner {
    /**
     * 
     * @type {number}
     * @memberof GetPublicProfile200ResponseBadgesInner
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetPublicProfile200ResponseBadgesInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetPublicProfile200ResponseBadgesInner
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof GetPublicProfile200ResponseBadgesInner
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPublicProfile200ResponseBadgesInner
     */
    'updated_at'?: string;
}
/**
 * 
 * @export
 * @interface GetPublicShop200Response
 */
export interface GetPublicShop200Response {
    /**
     * 
     * @type {number}
     * @memberof GetPublicShop200Response
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GetPublicShop200Response
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetPublicShop200Response
     */
    'nameKana': string;
    /**
     * 
     * @type {string}
     * @memberof GetPublicShop200Response
     */
    'address': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetPublicShop200Response
     */
    'official': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetPublicShop200Response
     */
    'tel': string;
    /**
     * 
     * @type {string}
     * @memberof GetPublicShop200Response
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof GetPublicShop200Response
     */
    'nearestStation': string;
    /**
     * 
     * @type {number}
     * @memberof GetPublicShop200Response
     */
    'numberOfSeats': number;
    /**
     * 
     * @type {boolean}
     * @memberof GetPublicShop200Response
     */
    'isPublic': boolean;
    /**
     * 
     * @type {number}
     * @memberof GetPublicShop200Response
     */
    'requestUserId': number;
    /**
     * 
     * @type {Array<Image>}
     * @memberof GetPublicShop200Response
     */
    'images'?: Array<Image> | null;
    /**
     * 
     * @type {string}
     * @memberof GetPublicShop200Response
     */
    'homepage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPublicShop200Response
     */
    'googleMapUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPublicShop200Response
     */
    'googleMapIframe'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPublicShop200Response
     */
    'note'?: string | null;
    /**
     * 
     * @type {Array<GetCafeNotes200ResponseInnerShopPaymentMethodsInner>}
     * @memberof GetPublicShop200Response
     */
    'paymentMethods': Array<GetCafeNotes200ResponseInnerShopPaymentMethodsInner>;
    /**
     * 
     * @type {Array<Feature>}
     * @memberof GetPublicShop200Response
     */
    'features': Array<Feature>;
    /**
     * 
     * @type {Array<GetCafeNotes200ResponseInnerShopBudgetsInner>}
     * @memberof GetPublicShop200Response
     */
    'budgets': Array<GetCafeNotes200ResponseInnerShopBudgetsInner>;
    /**
     * 
     * @type {Array<GetCafeNotes200ResponseInnerShopOpeningHoursInner>}
     * @memberof GetPublicShop200Response
     */
    'openingHours': Array<GetCafeNotes200ResponseInnerShopOpeningHoursInner>;
    /**
     * 
     * @type {boolean}
     * @memberof GetPublicShop200Response
     */
    'favoriteFlag': boolean;
}
/**
 * 
 * @export
 * @interface GetPublicShops200ResponseInner
 */
export interface GetPublicShops200ResponseInner {
    /**
     * 
     * @type {number}
     * @memberof GetPublicShops200ResponseInner
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GetPublicShops200ResponseInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetPublicShops200ResponseInner
     */
    'nameKana': string;
    /**
     * 
     * @type {string}
     * @memberof GetPublicShops200ResponseInner
     */
    'address': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetPublicShops200ResponseInner
     */
    'official': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetPublicShops200ResponseInner
     */
    'tel': string;
    /**
     * 
     * @type {string}
     * @memberof GetPublicShops200ResponseInner
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof GetPublicShops200ResponseInner
     */
    'nearestStation': string;
    /**
     * 
     * @type {number}
     * @memberof GetPublicShops200ResponseInner
     */
    'numberOfSeats': number;
    /**
     * 
     * @type {boolean}
     * @memberof GetPublicShops200ResponseInner
     */
    'isPublic': boolean;
    /**
     * 
     * @type {number}
     * @memberof GetPublicShops200ResponseInner
     */
    'requestUserId': number;
    /**
     * 
     * @type {Array<PaymentMethods>}
     * @memberof GetPublicShops200ResponseInner
     */
    'paymentMethods': Array<PaymentMethods>;
    /**
     * 
     * @type {Array<Budgets>}
     * @memberof GetPublicShops200ResponseInner
     */
    'budgets': Array<Budgets>;
    /**
     * 
     * @type {Array<OpeningHours>}
     * @memberof GetPublicShops200ResponseInner
     */
    'openingHours': Array<OpeningHours>;
    /**
     * 
     * @type {boolean}
     * @memberof GetPublicShops200ResponseInner
     */
    'favoriteFlag': boolean;
    /**
     * 
     * @type {Array<Image>}
     * @memberof GetPublicShops200ResponseInner
     */
    'images': Array<Image> | null;
    /**
     * 
     * @type {Array<Feature>}
     * @memberof GetPublicShops200ResponseInner
     */
    'features': Array<Feature>;
}
/**
 * 
 * @export
 * @interface GetShop200Response
 */
export interface GetShop200Response {
    /**
     * 
     * @type {number}
     * @memberof GetShop200Response
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GetShop200Response
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetShop200Response
     */
    'nameKana': string;
    /**
     * 
     * @type {string}
     * @memberof GetShop200Response
     */
    'address': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetShop200Response
     */
    'official': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetShop200Response
     */
    'tel': string;
    /**
     * 
     * @type {string}
     * @memberof GetShop200Response
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof GetShop200Response
     */
    'nearestStation': string;
    /**
     * 
     * @type {number}
     * @memberof GetShop200Response
     */
    'numberOfSeats': number;
    /**
     * 
     * @type {boolean}
     * @memberof GetShop200Response
     */
    'isPublic': boolean;
    /**
     * 
     * @type {number}
     * @memberof GetShop200Response
     */
    'requestUserId'?: number | null;
    /**
     * 
     * @type {Array<Image>}
     * @memberof GetShop200Response
     */
    'images'?: Array<Image> | null;
    /**
     * 
     * @type {string}
     * @memberof GetShop200Response
     */
    'homepage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetShop200Response
     */
    'googleMapUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetShop200Response
     */
    'googleMapIframe'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetShop200Response
     */
    'note'?: string | null;
    /**
     * 
     * @type {Array<GetCafeNotes200ResponseInnerShopPaymentMethodsInner>}
     * @memberof GetShop200Response
     */
    'paymentMethods': Array<GetCafeNotes200ResponseInnerShopPaymentMethodsInner>;
    /**
     * 
     * @type {Array<GetCafeNotes200ResponseInnerShopPaymentMethodsInner>}
     * @memberof GetShop200Response
     */
    'features'?: Array<GetCafeNotes200ResponseInnerShopPaymentMethodsInner>;
    /**
     * 
     * @type {Array<GetShop200ResponseBudgetsInner>}
     * @memberof GetShop200Response
     */
    'budgets': Array<GetShop200ResponseBudgetsInner>;
    /**
     * 
     * @type {Array<GetShop200ResponseOpeningHoursInner>}
     * @memberof GetShop200Response
     */
    'openingHours': Array<GetShop200ResponseOpeningHoursInner>;
}
/**
 * 
 * @export
 * @interface GetShop200ResponseBudgetsInner
 */
export interface GetShop200ResponseBudgetsInner {
    /**
     * 
     * @type {number}
     * @memberof GetShop200ResponseBudgetsInner
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GetShop200ResponseBudgetsInner
     */
    'timeframe': string;
    /**
     * 
     * @type {number}
     * @memberof GetShop200ResponseBudgetsInner
     */
    'lower': number;
    /**
     * 
     * @type {number}
     * @memberof GetShop200ResponseBudgetsInner
     */
    'upper': number;
}
/**
 * 
 * @export
 * @interface GetShop200ResponseOpeningHoursInner
 */
export interface GetShop200ResponseOpeningHoursInner {
    /**
     * 
     * @type {number}
     * @memberof GetShop200ResponseOpeningHoursInner
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetShop200ResponseOpeningHoursInner
     */
    'dayOfWeek': string;
    /**
     * 
     * @type {string}
     * @memberof GetShop200ResponseOpeningHoursInner
     */
    'openingTime': string;
    /**
     * 
     * @type {string}
     * @memberof GetShop200ResponseOpeningHoursInner
     */
    'closingTime': string;
}
/**
 * 
 * @export
 * @interface GetShops200ResponseInner
 */
export interface GetShops200ResponseInner {
    /**
     * 
     * @type {number}
     * @memberof GetShops200ResponseInner
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GetShops200ResponseInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetShops200ResponseInner
     */
    'nameKana': string;
    /**
     * 
     * @type {string}
     * @memberof GetShops200ResponseInner
     */
    'address': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetShops200ResponseInner
     */
    'official': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetShops200ResponseInner
     */
    'tel': string;
    /**
     * 
     * @type {string}
     * @memberof GetShops200ResponseInner
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof GetShops200ResponseInner
     */
    'nearestStation': string;
    /**
     * 
     * @type {number}
     * @memberof GetShops200ResponseInner
     */
    'numberOfSeats': number;
    /**
     * 
     * @type {boolean}
     * @memberof GetShops200ResponseInner
     */
    'isPublic': boolean;
    /**
     * 
     * @type {number}
     * @memberof GetShops200ResponseInner
     */
    'requestUserId': number;
    /**
     * 
     * @type {Array<PaymentMethods>}
     * @memberof GetShops200ResponseInner
     */
    'paymentMethods': Array<PaymentMethods>;
    /**
     * 
     * @type {Array<Budgets>}
     * @memberof GetShops200ResponseInner
     */
    'budgets': Array<Budgets>;
    /**
     * 
     * @type {Array<OpeningHours>}
     * @memberof GetShops200ResponseInner
     */
    'openingHours': Array<OpeningHours>;
    /**
     * 
     * @type {Array<Image>}
     * @memberof GetShops200ResponseInner
     */
    'images'?: Array<Image> | null;
    /**
     * 
     * @type {string}
     * @memberof GetShops200ResponseInner
     */
    'homepage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetShops200ResponseInner
     */
    'googleMapUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetShops200ResponseInner
     */
    'googleMapIframe'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetShops200ResponseInner
     */
    'note'?: string | null;
}
/**
 * 
 * @export
 * @interface GetUserRequestShops200ResponseInner
 */
export interface GetUserRequestShops200ResponseInner {
    /**
     * 
     * @type {number}
     * @memberof GetUserRequestShops200ResponseInner
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GetUserRequestShops200ResponseInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserRequestShops200ResponseInner
     */
    'nameKana': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserRequestShops200ResponseInner
     */
    'address': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserRequestShops200ResponseInner
     */
    'official': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetUserRequestShops200ResponseInner
     */
    'tel': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserRequestShops200ResponseInner
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserRequestShops200ResponseInner
     */
    'nearestStation': string;
    /**
     * 
     * @type {number}
     * @memberof GetUserRequestShops200ResponseInner
     */
    'numberOfSeats': number;
    /**
     * 
     * @type {number}
     * @memberof GetUserRequestShops200ResponseInner
     */
    'requestUserId': number;
    /**
     * 
     * @type {Array<Image>}
     * @memberof GetUserRequestShops200ResponseInner
     */
    'images'?: Array<Image> | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserRequestShops200ResponseInner
     */
    'homepage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserRequestShops200ResponseInner
     */
    'googleMapUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserRequestShops200ResponseInner
     */
    'googleMapIframe'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserRequestShops200ResponseInner
     */
    'note'?: string | null;
    /**
     * 
     * @type {Array<GetCafeNotes200ResponseInnerShopPaymentMethodsInner>}
     * @memberof GetUserRequestShops200ResponseInner
     */
    'paymentMethods': Array<GetCafeNotes200ResponseInnerShopPaymentMethodsInner>;
    /**
     * 
     * @type {Array<GetCafeNotes200ResponseInnerShopPaymentMethodsInner>}
     * @memberof GetUserRequestShops200ResponseInner
     */
    'features': Array<GetCafeNotes200ResponseInnerShopPaymentMethodsInner>;
    /**
     * 
     * @type {Array<GetCafeNotes200ResponseInnerShopBudgetsInner>}
     * @memberof GetUserRequestShops200ResponseInner
     */
    'draftBudgets': Array<GetCafeNotes200ResponseInnerShopBudgetsInner>;
    /**
     * 
     * @type {Array<GetCafeNotes200ResponseInnerShopOpeningHoursInner>}
     * @memberof GetUserRequestShops200ResponseInner
     */
    'draftOpeningHours': Array<GetCafeNotes200ResponseInnerShopOpeningHoursInner>;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserRequestShops200ResponseInner
     */
    'approvalFlag': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetUserRequestShops200ResponseInner
     */
    'approvalStatus'?: GetUserRequestShops200ResponseInnerApprovalStatusEnum;
}

export const GetUserRequestShops200ResponseInnerApprovalStatusEnum = {
    Unapproved: 'unapproved',
    Approved: 'approved',
    Rejected: 'rejected'
} as const;

export type GetUserRequestShops200ResponseInnerApprovalStatusEnum = typeof GetUserRequestShops200ResponseInnerApprovalStatusEnum[keyof typeof GetUserRequestShops200ResponseInnerApprovalStatusEnum];

/**
 * 
 * @export
 * @interface GetUserSession200Response
 */
export interface GetUserSession200Response {
    /**
     * 
     * @type {number}
     * @memberof GetUserSession200Response
     */
    'userId': number;
}
/**
 * 
 * @export
 * @interface GetUserSession401Response
 */
export interface GetUserSession401Response {
    /**
     * 
     * @type {string}
     * @memberof GetUserSession401Response
     */
    'error': string;
}
/**
 * 
 * @export
 * @interface Image
 */
export interface Image {
    /**
     * 
     * @type {number}
     * @memberof Image
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface OpeningHour
 */
export interface OpeningHour {
    /**
     * 
     * @type {number}
     * @memberof OpeningHour
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof OpeningHour
     */
    'dayOfWeek': string;
    /**
     * 
     * @type {string}
     * @memberof OpeningHour
     */
    'openingTime': string;
    /**
     * 
     * @type {string}
     * @memberof OpeningHour
     */
    'closingTime': string;
}
/**
 * 
 * @export
 * @interface OpeningHours
 */
export interface OpeningHours {
    /**
     * 
     * @type {string}
     * @memberof OpeningHours
     */
    'dayOfWeek': string;
    /**
     * 
     * @type {string}
     * @memberof OpeningHours
     */
    'openingTime': string;
    /**
     * 
     * @type {string}
     * @memberof OpeningHours
     */
    'closingTime': string;
}
/**
 * 
 * @export
 * @interface OwnerLoginRequest
 */
export interface OwnerLoginRequest {
    /**
     * 
     * @type {UserLoginRequestUser}
     * @memberof OwnerLoginRequest
     */
    'owner': UserLoginRequestUser;
}
/**
 * 
 * @export
 * @interface PaymentMethod
 */
export interface PaymentMethod {
    /**
     * 
     * @type {number}
     * @memberof PaymentMethod
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethod
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface PaymentMethods
 */
export interface PaymentMethods {
    /**
     * 
     * @type {number}
     * @memberof PaymentMethods
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethods
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface PostAdministratorDraftShopApproval200Response
 */
export interface PostAdministratorDraftShopApproval200Response {
    /**
     * 
     * @type {string}
     * @memberof PostAdministratorDraftShopApproval200Response
     */
    'message': string;
    /**
     * 
     * @type {number}
     * @memberof PostAdministratorDraftShopApproval200Response
     */
    'shop_id': number;
    /**
     * 
     * @type {string}
     * @memberof PostAdministratorDraftShopApproval200Response
     */
    'approval_status': string;
}
/**
 * 
 * @export
 * @interface PostAdministratorDraftShopApprovalRequest
 */
export interface PostAdministratorDraftShopApprovalRequest {
    /**
     * 
     * @type {number}
     * @memberof PostAdministratorDraftShopApprovalRequest
     */
    'draftShopId': number;
    /**
     * 
     * @type {string}
     * @memberof PostAdministratorDraftShopApprovalRequest
     */
    'approvalStatus': PostAdministratorDraftShopApprovalRequestApprovalStatusEnum;
}

export const PostAdministratorDraftShopApprovalRequestApprovalStatusEnum = {
    Unapproved: 'unapproved',
    Approved: 'approved',
    Rejected: 'rejected'
} as const;

export type PostAdministratorDraftShopApprovalRequestApprovalStatusEnum = typeof PostAdministratorDraftShopApprovalRequestApprovalStatusEnum[keyof typeof PostAdministratorDraftShopApprovalRequestApprovalStatusEnum];

/**
 * 
 * @export
 * @interface PostCafeNote200Response
 */
export interface PostCafeNote200Response {
    /**
     * 
     * @type {number}
     * @memberof PostCafeNote200Response
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof PostCafeNote200Response
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface PostCafeNoteRequest
 */
export interface PostCafeNoteRequest {
    /**
     * 
     * @type {PostCafeNoteRequestCafeNote}
     * @memberof PostCafeNoteRequest
     */
    'cafeNote': PostCafeNoteRequestCafeNote;
}
/**
 * 
 * @export
 * @interface PostCafeNoteRequestCafeNote
 */
export interface PostCafeNoteRequestCafeNote {
    /**
     * 
     * @type {string}
     * @memberof PostCafeNoteRequestCafeNote
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PostCafeNoteRequestCafeNote
     */
    'visitingDate': string | null;
    /**
     * 
     * @type {string}
     * @memberof PostCafeNoteRequestCafeNote
     */
    'body': string | null;
    /**
     * 
     * @type {number}
     * @memberof PostCafeNoteRequestCafeNote
     */
    'shopId': number | null;
    /**
     * 
     * @type {number}
     * @memberof PostCafeNoteRequestCafeNote
     */
    'userId': number | null;
    /**
     * 
     * @type {Array<Image>}
     * @memberof PostCafeNoteRequestCafeNote
     */
    'images'?: Array<Image> | null;
    /**
     * 
     * @type {boolean}
     * @memberof PostCafeNoteRequestCafeNote
     */
    'isPublic'?: boolean | null;
}
/**
 * 
 * @export
 * @interface PostFavoriteShopRequest
 */
export interface PostFavoriteShopRequest {
    /**
     * 
     * @type {PostFavoriteShopRequestFavoriteShop}
     * @memberof PostFavoriteShopRequest
     */
    'favoriteShop'?: PostFavoriteShopRequestFavoriteShop;
}
/**
 * 
 * @export
 * @interface PostFavoriteShopRequestFavoriteShop
 */
export interface PostFavoriteShopRequestFavoriteShop {
    /**
     * 
     * @type {number}
     * @memberof PostFavoriteShopRequestFavoriteShop
     */
    'shopId': number;
    /**
     * 
     * @type {number}
     * @memberof PostFavoriteShopRequestFavoriteShop
     */
    'userId': number;
}
/**
 * 
 * @export
 * @interface PutAdministratorShopRequest
 */
export interface PutAdministratorShopRequest {
    /**
     * 
     * @type {PutAdministratorShopRequestShop}
     * @memberof PutAdministratorShopRequest
     */
    'shop': PutAdministratorShopRequestShop;
}
/**
 * 
 * @export
 * @interface PutAdministratorShopRequestShop
 */
export interface PutAdministratorShopRequestShop {
    /**
     * 
     * @type {string}
     * @memberof PutAdministratorShopRequestShop
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PutAdministratorShopRequestShop
     */
    'nameKana': string;
    /**
     * 
     * @type {string}
     * @memberof PutAdministratorShopRequestShop
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof PutAdministratorShopRequestShop
     */
    'tel': string;
    /**
     * 
     * @type {string}
     * @memberof PutAdministratorShopRequestShop
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof PutAdministratorShopRequestShop
     */
    'nearestStation': string;
    /**
     * 
     * @type {number}
     * @memberof PutAdministratorShopRequestShop
     */
    'numberOfSeats': number;
    /**
     * 
     * @type {Array<number>}
     * @memberof PutAdministratorShopRequestShop
     */
    'paymentMethodIds': Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PutAdministratorShopRequestShop
     */
    'featureIds': Array<number>;
    /**
     * 
     * @type {Array<PutDraftShopRequestShopBudgetsAttributesInner>}
     * @memberof PutAdministratorShopRequestShop
     */
    'budgetsAttributes': Array<PutDraftShopRequestShopBudgetsAttributesInner>;
    /**
     * 
     * @type {Array<PutDraftShopRequestShopOpeningHoursAttributesInner>}
     * @memberof PutAdministratorShopRequestShop
     */
    'openingHoursAttributes': Array<PutDraftShopRequestShopOpeningHoursAttributesInner>;
    /**
     * 
     * @type {Array<Image>}
     * @memberof PutAdministratorShopRequestShop
     */
    'images': Array<Image> | null;
    /**
     * 
     * @type {string}
     * @memberof PutAdministratorShopRequestShop
     */
    'homepage': string;
    /**
     * 
     * @type {string}
     * @memberof PutAdministratorShopRequestShop
     */
    'googleMapUrl': string;
    /**
     * 
     * @type {string}
     * @memberof PutAdministratorShopRequestShop
     */
    'googleMapIframe': string;
    /**
     * 
     * @type {string}
     * @memberof PutAdministratorShopRequestShop
     */
    'note'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PutAdministratorShopRequestShop
     */
    'isPublic': boolean;
}
/**
 * 
 * @export
 * @interface PutDraftShop200Response
 */
export interface PutDraftShop200Response {
    /**
     * 
     * @type {string}
     * @memberof PutDraftShop200Response
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface PutDraftShopRequest
 */
export interface PutDraftShopRequest {
    /**
     * 
     * @type {PutDraftShopRequestShop}
     * @memberof PutDraftShopRequest
     */
    'shop': PutDraftShopRequestShop;
}
/**
 * 
 * @export
 * @interface PutDraftShopRequestShop
 */
export interface PutDraftShopRequestShop {
    /**
     * 
     * @type {string}
     * @memberof PutDraftShopRequestShop
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PutDraftShopRequestShop
     */
    'nameKana': string;
    /**
     * 
     * @type {string}
     * @memberof PutDraftShopRequestShop
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof PutDraftShopRequestShop
     */
    'tel': string;
    /**
     * 
     * @type {string}
     * @memberof PutDraftShopRequestShop
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof PutDraftShopRequestShop
     */
    'nearestStation': string;
    /**
     * 
     * @type {number}
     * @memberof PutDraftShopRequestShop
     */
    'numberOfSeats': number;
    /**
     * 
     * @type {Array<number>}
     * @memberof PutDraftShopRequestShop
     */
    'paymentMethodIds': Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PutDraftShopRequestShop
     */
    'featureIds': Array<number>;
    /**
     * 
     * @type {Array<PutDraftShopRequestShopBudgetsAttributesInner>}
     * @memberof PutDraftShopRequestShop
     */
    'budgetsAttributes': Array<PutDraftShopRequestShopBudgetsAttributesInner>;
    /**
     * 
     * @type {Array<PutDraftShopRequestShopOpeningHoursAttributesInner>}
     * @memberof PutDraftShopRequestShop
     */
    'openingHoursAttributes': Array<PutDraftShopRequestShopOpeningHoursAttributesInner>;
    /**
     * 
     * @type {Array<Image>}
     * @memberof PutDraftShopRequestShop
     */
    'images': Array<Image> | null;
    /**
     * 
     * @type {string}
     * @memberof PutDraftShopRequestShop
     */
    'homepage': string;
    /**
     * 
     * @type {string}
     * @memberof PutDraftShopRequestShop
     */
    'googleMapUrl': string;
    /**
     * 
     * @type {string}
     * @memberof PutDraftShopRequestShop
     */
    'googleMapIframe': string;
    /**
     * 
     * @type {string}
     * @memberof PutDraftShopRequestShop
     */
    'note'?: string;
    /**
     * 
     * @type {number}
     * @memberof PutDraftShopRequestShop
     */
    'requestUserId': number | null;
}
/**
 * 
 * @export
 * @interface PutDraftShopRequestShopBudgetsAttributesInner
 */
export interface PutDraftShopRequestShopBudgetsAttributesInner {
    /**
     * 
     * @type {number}
     * @memberof PutDraftShopRequestShopBudgetsAttributesInner
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof PutDraftShopRequestShopBudgetsAttributesInner
     */
    'timeframe': number;
    /**
     * 
     * @type {number}
     * @memberof PutDraftShopRequestShopBudgetsAttributesInner
     */
    'lower': number;
    /**
     * 
     * @type {number}
     * @memberof PutDraftShopRequestShopBudgetsAttributesInner
     */
    'upper': number;
}
/**
 * 
 * @export
 * @interface PutDraftShopRequestShopOpeningHoursAttributesInner
 */
export interface PutDraftShopRequestShopOpeningHoursAttributesInner {
    /**
     * 
     * @type {number}
     * @memberof PutDraftShopRequestShopOpeningHoursAttributesInner
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof PutDraftShopRequestShopOpeningHoursAttributesInner
     */
    'dayOfWeek': number;
    /**
     * 
     * @type {string}
     * @memberof PutDraftShopRequestShopOpeningHoursAttributesInner
     */
    'openingTime': string;
    /**
     * 
     * @type {string}
     * @memberof PutDraftShopRequestShopOpeningHoursAttributesInner
     */
    'closingTime': string;
    /**
     * 
     * @type {boolean}
     * @memberof PutDraftShopRequestShopOpeningHoursAttributesInner
     */
    '_destroy'?: boolean | null;
}
/**
 * 
 * @export
 * @interface UpdateCafeNoteRequest
 */
export interface UpdateCafeNoteRequest {
    /**
     * 
     * @type {UpdateCafeNoteRequestCafeNote}
     * @memberof UpdateCafeNoteRequest
     */
    'cafeNote': UpdateCafeNoteRequestCafeNote;
}
/**
 * 
 * @export
 * @interface UpdateCafeNoteRequestCafeNote
 */
export interface UpdateCafeNoteRequestCafeNote {
    /**
     * 
     * @type {number}
     * @memberof UpdateCafeNoteRequestCafeNote
     */
    'shopId': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateCafeNoteRequestCafeNote
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCafeNoteRequestCafeNote
     */
    'visitingDate': string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCafeNoteRequestCafeNote
     */
    'body': string | null;
    /**
     * 
     * @type {Array<Image>}
     * @memberof UpdateCafeNoteRequestCafeNote
     */
    'images'?: Array<Image> | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCafeNoteRequestCafeNote
     */
    'isPublic'?: boolean | null;
}
/**
 * 
 * @export
 * @interface UpdateProfileRequest
 */
export interface UpdateProfileRequest {
    /**
     * 
     * @type {UpdateProfileRequestUser}
     * @memberof UpdateProfileRequest
     */
    'user': UpdateProfileRequestUser;
}
/**
 * 
 * @export
 * @interface UpdateProfileRequestUser
 */
export interface UpdateProfileRequestUser {
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileRequestUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileRequestUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileRequestUser
     */
    'birthday': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileRequestUser
     */
    'password': string;
    /**
     * 
     * @type {UpdateProfileRequestUserImage}
     * @memberof UpdateProfileRequestUser
     */
    'image'?: UpdateProfileRequestUserImage;
}
/**
 * 
 * @export
 * @interface UpdateProfileRequestUserImage
 */
export interface UpdateProfileRequestUserImage {
    /**
     * 
     * @type {number}
     * @memberof UpdateProfileRequestUserImage
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileRequestUserImage
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface UserActivatedRequest
 */
export interface UserActivatedRequest {
    /**
     * 
     * @type {UserActivatedRequestAccountActivation}
     * @memberof UserActivatedRequest
     */
    'account_activation': UserActivatedRequestAccountActivation;
}
/**
 * 
 * @export
 * @interface UserActivatedRequestAccountActivation
 */
export interface UserActivatedRequestAccountActivation {
    /**
     * 
     * @type {string}
     * @memberof UserActivatedRequestAccountActivation
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UserActivatedRequestAccountActivation
     */
    'activation_token': string;
}
/**
 * 
 * @export
 * @interface UserLoginRequest
 */
export interface UserLoginRequest {
    /**
     * 
     * @type {UserLoginRequestUser}
     * @memberof UserLoginRequest
     */
    'user': UserLoginRequestUser;
}
/**
 * 
 * @export
 * @interface UserLoginRequestUser
 */
export interface UserLoginRequestUser {
    /**
     * 
     * @type {string}
     * @memberof UserLoginRequestUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UserLoginRequestUser
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface UserPasswordResetReceptionRequest
 */
export interface UserPasswordResetReceptionRequest {
    /**
     * 
     * @type {UserPasswordResetReceptionRequestPasswordReset}
     * @memberof UserPasswordResetReceptionRequest
     */
    'passwordReset': UserPasswordResetReceptionRequestPasswordReset;
}
/**
 * 
 * @export
 * @interface UserPasswordResetReceptionRequestPasswordReset
 */
export interface UserPasswordResetReceptionRequestPasswordReset {
    /**
     * 
     * @type {string}
     * @memberof UserPasswordResetReceptionRequestPasswordReset
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface UserPasswordResetRequest
 */
export interface UserPasswordResetRequest {
    /**
     * 
     * @type {UserPasswordResetRequestPasswordReset}
     * @memberof UserPasswordResetRequest
     */
    'passwordReset': UserPasswordResetRequestPasswordReset;
}
/**
 * 
 * @export
 * @interface UserPasswordResetRequestPasswordReset
 */
export interface UserPasswordResetRequestPasswordReset {
    /**
     * 
     * @type {string}
     * @memberof UserPasswordResetRequestPasswordReset
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UserPasswordResetRequestPasswordReset
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof UserPasswordResetRequestPasswordReset
     */
    'passwordConfirmation': string;
    /**
     * 
     * @type {string}
     * @memberof UserPasswordResetRequestPasswordReset
     */
    'resetToken': string | null;
}

/**
 * V1Api - axios parameter creator
 * @export
 */
export const V1ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary administrator login
         * @param {AdministratorLoginRequest} [administratorLoginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administratorLogin: async (administratorLoginRequest?: AdministratorLoginRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/administrators/auths`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(administratorLoginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary post administrator shops
         * @param {CreateAdministratorShopRequest} [createAdministratorShopRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdministratorShop: async (createAdministratorShopRequest?: CreateAdministratorShopRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/administrators/shops`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAdministratorShopRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary post draft shops
         * @param {CreateDraftShopRequest} [createDraftShopRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDraftShop: async (createDraftShopRequest?: CreateDraftShopRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/draft_shops`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDraftShopRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary owner sign up
         * @param {CreateOwnerRequest} [createOwnerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOwner: async (createOwnerRequest?: CreateOwnerRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/owners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOwnerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary post shops
         * @param {CreateShopRequest} [createShopRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShop: async (createShopRequest?: CreateShopRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/shops`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createShopRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary user sign up
         * @param {CreateUserRequest} [createUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: async (createUserRequest?: CreateUserRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary DELETE cafe note
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCafeNote: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteCafeNote', 'id', id)
            const localVarPath = `/api/v1/users/cafe_notes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get administrator draft shop
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdministratorDraftShop: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAdministratorDraftShop', 'id', id)
            const localVarPath = `/api/v1/administrators/draft_shops/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get administrator draft shops
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdministratorDraftShops: async (page?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/administrators/draft_shops`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary administrator session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdministratorSession: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/administrators/session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get administrator shop
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdministratorShop: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAdministratorShop', 'id', id)
            const localVarPath = `/api/v1/administrators/shops/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get administrator shops
         * @param {number} [page] 
         * @param {string} [area] 
         * @param {string} [shopName] 
         * @param {'morning' | 'lunch' | 'dinner'} [timeframe] 
         * @param {string} [upperBudget] 
         * @param {Array<string>} [featureIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdministratorShops: async (page?: number, area?: string, shopName?: string, timeframe?: 'morning' | 'lunch' | 'dinner', upperBudget?: string, featureIds?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/administrators/shops`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (area !== undefined) {
                localVarQueryParameter['area'] = area;
            }

            if (shopName !== undefined) {
                localVarQueryParameter['shopName'] = shopName;
            }

            if (timeframe !== undefined) {
                localVarQueryParameter['timeframe'] = timeframe;
            }

            if (upperBudget !== undefined) {
                localVarQueryParameter['upperBudget'] = upperBudget;
            }

            if (featureIds) {
                localVarQueryParameter['featureIds'] = featureIds.join(COLLECTION_FORMATS.csv);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get administrators features
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdministratorsFeatures: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/administrators/features`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get administrators payment methods
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdministratorsPaymentMethods: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/administrators/payment_methods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get administrators users
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdministratorsUsers: async (page?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/administrators/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GET cafe note
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCafeNote: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCafeNote', 'id', id)
            const localVarPath = `/api/v1/users/cafe_notes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GET cafe notes
         * @param {number} [page] 
         * @param {number} [per] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCafeNotes: async (page?: number, per?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/cafe_notes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (per !== undefined) {
                localVarQueryParameter['per'] = per;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get features
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatures: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/features`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get payment methods
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentMethods: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/payment_methods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfile: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/profiles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get public cafe note
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicCafeNote: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPublicCafeNote', 'id', id)
            const localVarPath = `/api/v1/users/public_cafe_notes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get public cafe note
         * @param {number} [page] 
         * @param {number} [per] 
         * @param {number} [shopId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicCafeNotes: async (page?: number, per?: number, shopId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/public_cafe_notes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (per !== undefined) {
                localVarQueryParameter['per'] = per;
            }

            if (shopId !== undefined) {
                localVarQueryParameter['shopId'] = shopId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get public profile
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicProfile: async (username: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('getPublicProfile', 'username', username)
            const localVarPath = `/api/v1/users/public_profiles/{username}`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get public shop
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicShop: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPublicShop', 'id', id)
            const localVarPath = `/api/v1/public_shops/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get public shops
         * @param {number} [page] 
         * @param {number} [per] 
         * @param {string} [area] 
         * @param {string} [shopName] 
         * @param {'morning' | 'lunch' | 'dinner'} [timeframe] 
         * @param {string} [upperBudget] 
         * @param {Array<string>} [featureIds] 
         * @param {boolean} [favoriteFlag] 
         * @param {boolean} [visitFlag] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicShops: async (page?: number, per?: number, area?: string, shopName?: string, timeframe?: 'morning' | 'lunch' | 'dinner', upperBudget?: string, featureIds?: Array<string>, favoriteFlag?: boolean, visitFlag?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/public_shops`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (per !== undefined) {
                localVarQueryParameter['per'] = per;
            }

            if (area !== undefined) {
                localVarQueryParameter['area'] = area;
            }

            if (shopName !== undefined) {
                localVarQueryParameter['shopName'] = shopName;
            }

            if (timeframe !== undefined) {
                localVarQueryParameter['timeframe'] = timeframe;
            }

            if (upperBudget !== undefined) {
                localVarQueryParameter['upperBudget'] = upperBudget;
            }

            if (featureIds) {
                localVarQueryParameter['featureIds'] = featureIds.join(COLLECTION_FORMATS.csv);
            }

            if (favoriteFlag !== undefined) {
                localVarQueryParameter['favoriteFlag'] = favoriteFlag;
            }

            if (visitFlag !== undefined) {
                localVarQueryParameter['visitFlag'] = visitFlag;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get shop
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShop: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getShop', 'id', id)
            const localVarPath = `/api/v1/shops/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get shops
         * @param {number} [page] 
         * @param {number} [userId] 
         * @param {number} [per] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShops: async (page?: number, userId?: number, per?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/shops`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (per !== undefined) {
                localVarQueryParameter['per'] = per;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GET user request shop
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserRequestShop: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getUserRequestShop', 'id', id)
            const localVarPath = `/api/v1/users/request_shops/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GET user request shops
         * @param {number} [page] 
         * @param {number} [per] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserRequestShops: async (page?: number, per?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/request_shops`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (per !== undefined) {
                localVarQueryParameter['per'] = per;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary user session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserSession: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary owner account activations
         * @param {UserActivatedRequest} [userActivatedRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ownerActivated: async (userActivatedRequest?: UserActivatedRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/owners/account_activations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userActivatedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary owner login
         * @param {OwnerLoginRequest} [ownerLoginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ownerLogin: async (ownerLoginRequest?: OwnerLoginRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/owners/auths`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ownerLoginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary post administrator draft shop approval
         * @param {PostAdministratorDraftShopApprovalRequest} [postAdministratorDraftShopApprovalRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdministratorDraftShopApproval: async (postAdministratorDraftShopApprovalRequest?: PostAdministratorDraftShopApprovalRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/administrators/draft_shops/approval`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postAdministratorDraftShopApprovalRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary POST cafe note
         * @param {PostCafeNoteRequest} [postCafeNoteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCafeNote: async (postCafeNoteRequest?: PostCafeNoteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/cafe_notes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postCafeNoteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary post favorite
         * @param {PostFavoriteShopRequest} [postFavoriteShopRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFavoriteShop: async (postFavoriteShopRequest?: PostFavoriteShopRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/shops/favorite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postFavoriteShopRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary put administrator shop
         * @param {number} id 
         * @param {PutAdministratorShopRequest} [putAdministratorShopRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putAdministratorShop: async (id: number, putAdministratorShopRequest?: PutAdministratorShopRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('putAdministratorShop', 'id', id)
            const localVarPath = `/api/v1/administrators/shops/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putAdministratorShopRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary put draft shop
         * @param {number} id 
         * @param {PutDraftShopRequest} [putDraftShopRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putDraftShop: async (id: number, putDraftShopRequest?: PutDraftShopRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('putDraftShop', 'id', id)
            const localVarPath = `/api/v1/users/draft_shops/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putDraftShopRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary PATCH cafe note
         * @param {number} id 
         * @param {UpdateCafeNoteRequest} [updateCafeNoteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCafeNote: async (id: number, updateCafeNoteRequest?: UpdateCafeNoteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCafeNote', 'id', id)
            const localVarPath = `/api/v1/users/cafe_notes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCafeNoteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update profile
         * @param {UpdateProfileRequest} [updateProfileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfile: async (updateProfileRequest?: UpdateProfileRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/profiles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProfileRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary user account activations
         * @param {UserActivatedRequest} [userActivatedRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userActivated: async (userActivatedRequest?: UserActivatedRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/account_activations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userActivatedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary user login
         * @param {UserLoginRequest} [userLoginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userLogin: async (userLoginRequest?: UserLoginRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/auths`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userLoginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary user logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userLogout: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/auths`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary user password reset
         * @param {UserPasswordResetRequest} [userPasswordResetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPasswordReset: async (userPasswordResetRequest?: UserPasswordResetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/password_resets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userPasswordResetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary user password reset reception
         * @param {UserPasswordResetReceptionRequest} [userPasswordResetReceptionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPasswordResetReception: async (userPasswordResetReceptionRequest?: UserPasswordResetReceptionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/password_resets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userPasswordResetReceptionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * V1Api - functional programming interface
 * @export
 */
export const V1ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = V1ApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary administrator login
         * @param {AdministratorLoginRequest} [administratorLoginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async administratorLogin(administratorLoginRequest?: AdministratorLoginRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateUser200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.administratorLogin(administratorLoginRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary post administrator shops
         * @param {CreateAdministratorShopRequest} [createAdministratorShopRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAdministratorShop(createAdministratorShopRequest?: CreateAdministratorShopRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateUser200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAdministratorShop(createAdministratorShopRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary post draft shops
         * @param {CreateDraftShopRequest} [createDraftShopRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDraftShop(createDraftShopRequest?: CreateDraftShopRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateUser200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDraftShop(createDraftShopRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary owner sign up
         * @param {CreateOwnerRequest} [createOwnerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOwner(createOwnerRequest?: CreateOwnerRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateUser200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOwner(createOwnerRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary post shops
         * @param {CreateShopRequest} [createShopRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createShop(createShopRequest?: CreateShopRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateUser200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createShop(createShopRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary user sign up
         * @param {CreateUserRequest} [createUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUser(createUserRequest?: CreateUserRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateUser200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUser(createUserRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary DELETE cafe note
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCafeNote(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateUser200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCafeNote(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get administrator draft shop
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdministratorDraftShop(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAdministratorDraftShop200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdministratorDraftShop(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get administrator draft shops
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdministratorDraftShops(page?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetAdministratorDraftShops200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdministratorDraftShops(page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary administrator session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdministratorSession(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAdministratorSession200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdministratorSession(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get administrator shop
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdministratorShop(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAdministratorShop200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdministratorShop(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get administrator shops
         * @param {number} [page] 
         * @param {string} [area] 
         * @param {string} [shopName] 
         * @param {'morning' | 'lunch' | 'dinner'} [timeframe] 
         * @param {string} [upperBudget] 
         * @param {Array<string>} [featureIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdministratorShops(page?: number, area?: string, shopName?: string, timeframe?: 'morning' | 'lunch' | 'dinner', upperBudget?: string, featureIds?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetAdministratorShops200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdministratorShops(page, area, shopName, timeframe, upperBudget, featureIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get administrators features
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdministratorsFeatures(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Features>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdministratorsFeatures(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get administrators payment methods
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdministratorsPaymentMethods(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PaymentMethods>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdministratorsPaymentMethods(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get administrators users
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdministratorsUsers(page?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetAdministratorsUsers200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdministratorsUsers(page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary GET cafe note
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCafeNote(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCafeNote200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCafeNote(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary GET cafe notes
         * @param {number} [page] 
         * @param {number} [per] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCafeNotes(page?: number, per?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetCafeNotes200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCafeNotes(page, per, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get features
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeatures(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Features>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeatures(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get payment methods
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentMethods(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PaymentMethods>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentMethods(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfile(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProfile200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfile(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get public cafe note
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublicCafeNote(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPublicCafeNote200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublicCafeNote(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get public cafe note
         * @param {number} [page] 
         * @param {number} [per] 
         * @param {number} [shopId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublicCafeNotes(page?: number, per?: number, shopId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetCafeNotes200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublicCafeNotes(page, per, shopId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get public profile
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublicProfile(username: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPublicProfile200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublicProfile(username, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get public shop
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublicShop(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPublicShop200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublicShop(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get public shops
         * @param {number} [page] 
         * @param {number} [per] 
         * @param {string} [area] 
         * @param {string} [shopName] 
         * @param {'morning' | 'lunch' | 'dinner'} [timeframe] 
         * @param {string} [upperBudget] 
         * @param {Array<string>} [featureIds] 
         * @param {boolean} [favoriteFlag] 
         * @param {boolean} [visitFlag] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublicShops(page?: number, per?: number, area?: string, shopName?: string, timeframe?: 'morning' | 'lunch' | 'dinner', upperBudget?: string, featureIds?: Array<string>, favoriteFlag?: boolean, visitFlag?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetPublicShops200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublicShops(page, per, area, shopName, timeframe, upperBudget, featureIds, favoriteFlag, visitFlag, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get shop
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShop(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetShop200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShop(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get shops
         * @param {number} [page] 
         * @param {number} [userId] 
         * @param {number} [per] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShops(page?: number, userId?: number, per?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetShops200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShops(page, userId, per, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary GET user request shop
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserRequestShop(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserRequestShops200ResponseInner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserRequestShop(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary GET user request shops
         * @param {number} [page] 
         * @param {number} [per] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserRequestShops(page?: number, per?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetUserRequestShops200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserRequestShops(page, per, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary user session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserSession(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserSession200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserSession(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary owner account activations
         * @param {UserActivatedRequest} [userActivatedRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ownerActivated(userActivatedRequest?: UserActivatedRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateUser200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ownerActivated(userActivatedRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary owner login
         * @param {OwnerLoginRequest} [ownerLoginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ownerLogin(ownerLoginRequest?: OwnerLoginRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateUser200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ownerLogin(ownerLoginRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary post administrator draft shop approval
         * @param {PostAdministratorDraftShopApprovalRequest} [postAdministratorDraftShopApprovalRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAdministratorDraftShopApproval(postAdministratorDraftShopApprovalRequest?: PostAdministratorDraftShopApprovalRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostAdministratorDraftShopApproval200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAdministratorDraftShopApproval(postAdministratorDraftShopApprovalRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary POST cafe note
         * @param {PostCafeNoteRequest} [postCafeNoteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCafeNote(postCafeNoteRequest?: PostCafeNoteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostCafeNote200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCafeNote(postCafeNoteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary post favorite
         * @param {PostFavoriteShopRequest} [postFavoriteShopRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postFavoriteShop(postFavoriteShopRequest?: PostFavoriteShopRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postFavoriteShop(postFavoriteShopRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary put administrator shop
         * @param {number} id 
         * @param {PutAdministratorShopRequest} [putAdministratorShopRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putAdministratorShop(id: number, putAdministratorShopRequest?: PutAdministratorShopRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutDraftShop200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putAdministratorShop(id, putAdministratorShopRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary put draft shop
         * @param {number} id 
         * @param {PutDraftShopRequest} [putDraftShopRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putDraftShop(id: number, putDraftShopRequest?: PutDraftShopRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutDraftShop200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putDraftShop(id, putDraftShopRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary PATCH cafe note
         * @param {number} id 
         * @param {UpdateCafeNoteRequest} [updateCafeNoteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCafeNote(id: number, updateCafeNoteRequest?: UpdateCafeNoteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateUser200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCafeNote(id, updateCafeNoteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary update profile
         * @param {UpdateProfileRequest} [updateProfileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProfile(updateProfileRequest?: UpdateProfileRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateUser200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProfile(updateProfileRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary user account activations
         * @param {UserActivatedRequest} [userActivatedRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userActivated(userActivatedRequest?: UserActivatedRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateUser200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userActivated(userActivatedRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary user login
         * @param {UserLoginRequest} [userLoginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userLogin(userLoginRequest?: UserLoginRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateUser200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userLogin(userLoginRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary user logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userLogout(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userLogout(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary user password reset
         * @param {UserPasswordResetRequest} [userPasswordResetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userPasswordReset(userPasswordResetRequest?: UserPasswordResetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateUser200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userPasswordReset(userPasswordResetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary user password reset reception
         * @param {UserPasswordResetReceptionRequest} [userPasswordResetReceptionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userPasswordResetReception(userPasswordResetReceptionRequest?: UserPasswordResetReceptionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateUser200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userPasswordResetReception(userPasswordResetReceptionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * V1Api - factory interface
 * @export
 */
export const V1ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = V1ApiFp(configuration)
    return {
        /**
         * 
         * @summary administrator login
         * @param {AdministratorLoginRequest} [administratorLoginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administratorLogin(administratorLoginRequest?: AdministratorLoginRequest, options?: any): AxiosPromise<CreateUser200Response> {
            return localVarFp.administratorLogin(administratorLoginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary post administrator shops
         * @param {CreateAdministratorShopRequest} [createAdministratorShopRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdministratorShop(createAdministratorShopRequest?: CreateAdministratorShopRequest, options?: any): AxiosPromise<CreateUser200Response> {
            return localVarFp.createAdministratorShop(createAdministratorShopRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary post draft shops
         * @param {CreateDraftShopRequest} [createDraftShopRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDraftShop(createDraftShopRequest?: CreateDraftShopRequest, options?: any): AxiosPromise<CreateUser200Response> {
            return localVarFp.createDraftShop(createDraftShopRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary owner sign up
         * @param {CreateOwnerRequest} [createOwnerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOwner(createOwnerRequest?: CreateOwnerRequest, options?: any): AxiosPromise<CreateUser200Response> {
            return localVarFp.createOwner(createOwnerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary post shops
         * @param {CreateShopRequest} [createShopRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShop(createShopRequest?: CreateShopRequest, options?: any): AxiosPromise<CreateUser200Response> {
            return localVarFp.createShop(createShopRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary user sign up
         * @param {CreateUserRequest} [createUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(createUserRequest?: CreateUserRequest, options?: any): AxiosPromise<CreateUser200Response> {
            return localVarFp.createUser(createUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary DELETE cafe note
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCafeNote(id: number, options?: any): AxiosPromise<CreateUser200Response> {
            return localVarFp.deleteCafeNote(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get administrator draft shop
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdministratorDraftShop(id: number, options?: any): AxiosPromise<GetAdministratorDraftShop200Response> {
            return localVarFp.getAdministratorDraftShop(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get administrator draft shops
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdministratorDraftShops(page?: number, options?: any): AxiosPromise<Array<GetAdministratorDraftShops200ResponseInner>> {
            return localVarFp.getAdministratorDraftShops(page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary administrator session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdministratorSession(options?: any): AxiosPromise<GetAdministratorSession200Response> {
            return localVarFp.getAdministratorSession(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get administrator shop
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdministratorShop(id: number, options?: any): AxiosPromise<GetAdministratorShop200Response> {
            return localVarFp.getAdministratorShop(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get administrator shops
         * @param {number} [page] 
         * @param {string} [area] 
         * @param {string} [shopName] 
         * @param {'morning' | 'lunch' | 'dinner'} [timeframe] 
         * @param {string} [upperBudget] 
         * @param {Array<string>} [featureIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdministratorShops(page?: number, area?: string, shopName?: string, timeframe?: 'morning' | 'lunch' | 'dinner', upperBudget?: string, featureIds?: Array<string>, options?: any): AxiosPromise<Array<GetAdministratorShops200ResponseInner>> {
            return localVarFp.getAdministratorShops(page, area, shopName, timeframe, upperBudget, featureIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get administrators features
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdministratorsFeatures(options?: any): AxiosPromise<Array<Features>> {
            return localVarFp.getAdministratorsFeatures(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get administrators payment methods
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdministratorsPaymentMethods(options?: any): AxiosPromise<Array<PaymentMethods>> {
            return localVarFp.getAdministratorsPaymentMethods(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get administrators users
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdministratorsUsers(page?: number, options?: any): AxiosPromise<Array<GetAdministratorsUsers200ResponseInner>> {
            return localVarFp.getAdministratorsUsers(page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary GET cafe note
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCafeNote(id: number, options?: any): AxiosPromise<GetCafeNote200Response> {
            return localVarFp.getCafeNote(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary GET cafe notes
         * @param {number} [page] 
         * @param {number} [per] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCafeNotes(page?: number, per?: number, options?: any): AxiosPromise<Array<GetCafeNotes200ResponseInner>> {
            return localVarFp.getCafeNotes(page, per, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get features
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatures(options?: any): AxiosPromise<Array<Features>> {
            return localVarFp.getFeatures(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get payment methods
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentMethods(options?: any): AxiosPromise<Array<PaymentMethods>> {
            return localVarFp.getPaymentMethods(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfile(options?: any): AxiosPromise<GetProfile200Response> {
            return localVarFp.getProfile(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get public cafe note
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicCafeNote(id: number, options?: any): AxiosPromise<GetPublicCafeNote200Response> {
            return localVarFp.getPublicCafeNote(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get public cafe note
         * @param {number} [page] 
         * @param {number} [per] 
         * @param {number} [shopId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicCafeNotes(page?: number, per?: number, shopId?: number, options?: any): AxiosPromise<Array<GetCafeNotes200ResponseInner>> {
            return localVarFp.getPublicCafeNotes(page, per, shopId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get public profile
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicProfile(username: string, options?: any): AxiosPromise<GetPublicProfile200Response> {
            return localVarFp.getPublicProfile(username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get public shop
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicShop(id: number, options?: any): AxiosPromise<GetPublicShop200Response> {
            return localVarFp.getPublicShop(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get public shops
         * @param {number} [page] 
         * @param {number} [per] 
         * @param {string} [area] 
         * @param {string} [shopName] 
         * @param {'morning' | 'lunch' | 'dinner'} [timeframe] 
         * @param {string} [upperBudget] 
         * @param {Array<string>} [featureIds] 
         * @param {boolean} [favoriteFlag] 
         * @param {boolean} [visitFlag] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicShops(page?: number, per?: number, area?: string, shopName?: string, timeframe?: 'morning' | 'lunch' | 'dinner', upperBudget?: string, featureIds?: Array<string>, favoriteFlag?: boolean, visitFlag?: boolean, options?: any): AxiosPromise<Array<GetPublicShops200ResponseInner>> {
            return localVarFp.getPublicShops(page, per, area, shopName, timeframe, upperBudget, featureIds, favoriteFlag, visitFlag, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get shop
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShop(id: number, options?: any): AxiosPromise<GetShop200Response> {
            return localVarFp.getShop(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get shops
         * @param {number} [page] 
         * @param {number} [userId] 
         * @param {number} [per] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShops(page?: number, userId?: number, per?: number, options?: any): AxiosPromise<Array<GetShops200ResponseInner>> {
            return localVarFp.getShops(page, userId, per, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary GET user request shop
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserRequestShop(id: number, options?: any): AxiosPromise<GetUserRequestShops200ResponseInner> {
            return localVarFp.getUserRequestShop(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary GET user request shops
         * @param {number} [page] 
         * @param {number} [per] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserRequestShops(page?: number, per?: number, options?: any): AxiosPromise<Array<GetUserRequestShops200ResponseInner>> {
            return localVarFp.getUserRequestShops(page, per, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary user session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserSession(options?: any): AxiosPromise<GetUserSession200Response> {
            return localVarFp.getUserSession(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary owner account activations
         * @param {UserActivatedRequest} [userActivatedRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ownerActivated(userActivatedRequest?: UserActivatedRequest, options?: any): AxiosPromise<CreateUser200Response> {
            return localVarFp.ownerActivated(userActivatedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary owner login
         * @param {OwnerLoginRequest} [ownerLoginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ownerLogin(ownerLoginRequest?: OwnerLoginRequest, options?: any): AxiosPromise<CreateUser200Response> {
            return localVarFp.ownerLogin(ownerLoginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary post administrator draft shop approval
         * @param {PostAdministratorDraftShopApprovalRequest} [postAdministratorDraftShopApprovalRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdministratorDraftShopApproval(postAdministratorDraftShopApprovalRequest?: PostAdministratorDraftShopApprovalRequest, options?: any): AxiosPromise<PostAdministratorDraftShopApproval200Response> {
            return localVarFp.postAdministratorDraftShopApproval(postAdministratorDraftShopApprovalRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary POST cafe note
         * @param {PostCafeNoteRequest} [postCafeNoteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCafeNote(postCafeNoteRequest?: PostCafeNoteRequest, options?: any): AxiosPromise<PostCafeNote200Response> {
            return localVarFp.postCafeNote(postCafeNoteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary post favorite
         * @param {PostFavoriteShopRequest} [postFavoriteShopRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFavoriteShop(postFavoriteShopRequest?: PostFavoriteShopRequest, options?: any): AxiosPromise<object> {
            return localVarFp.postFavoriteShop(postFavoriteShopRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary put administrator shop
         * @param {number} id 
         * @param {PutAdministratorShopRequest} [putAdministratorShopRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putAdministratorShop(id: number, putAdministratorShopRequest?: PutAdministratorShopRequest, options?: any): AxiosPromise<PutDraftShop200Response> {
            return localVarFp.putAdministratorShop(id, putAdministratorShopRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary put draft shop
         * @param {number} id 
         * @param {PutDraftShopRequest} [putDraftShopRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putDraftShop(id: number, putDraftShopRequest?: PutDraftShopRequest, options?: any): AxiosPromise<PutDraftShop200Response> {
            return localVarFp.putDraftShop(id, putDraftShopRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary PATCH cafe note
         * @param {number} id 
         * @param {UpdateCafeNoteRequest} [updateCafeNoteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCafeNote(id: number, updateCafeNoteRequest?: UpdateCafeNoteRequest, options?: any): AxiosPromise<CreateUser200Response> {
            return localVarFp.updateCafeNote(id, updateCafeNoteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update profile
         * @param {UpdateProfileRequest} [updateProfileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfile(updateProfileRequest?: UpdateProfileRequest, options?: any): AxiosPromise<CreateUser200Response> {
            return localVarFp.updateProfile(updateProfileRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary user account activations
         * @param {UserActivatedRequest} [userActivatedRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userActivated(userActivatedRequest?: UserActivatedRequest, options?: any): AxiosPromise<CreateUser200Response> {
            return localVarFp.userActivated(userActivatedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary user login
         * @param {UserLoginRequest} [userLoginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userLogin(userLoginRequest?: UserLoginRequest, options?: any): AxiosPromise<CreateUser200Response> {
            return localVarFp.userLogin(userLoginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary user logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userLogout(options?: any): AxiosPromise<object> {
            return localVarFp.userLogout(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary user password reset
         * @param {UserPasswordResetRequest} [userPasswordResetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPasswordReset(userPasswordResetRequest?: UserPasswordResetRequest, options?: any): AxiosPromise<CreateUser200Response> {
            return localVarFp.userPasswordReset(userPasswordResetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary user password reset reception
         * @param {UserPasswordResetReceptionRequest} [userPasswordResetReceptionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPasswordResetReception(userPasswordResetReceptionRequest?: UserPasswordResetReceptionRequest, options?: any): AxiosPromise<CreateUser200Response> {
            return localVarFp.userPasswordResetReception(userPasswordResetReceptionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * V1Api - object-oriented interface
 * @export
 * @class V1Api
 * @extends {BaseAPI}
 */
export class V1Api extends BaseAPI {
    /**
     * 
     * @summary administrator login
     * @param {AdministratorLoginRequest} [administratorLoginRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public administratorLogin(administratorLoginRequest?: AdministratorLoginRequest, options?: AxiosRequestConfig) {
        return V1ApiFp(this.configuration).administratorLogin(administratorLoginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary post administrator shops
     * @param {CreateAdministratorShopRequest} [createAdministratorShopRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public createAdministratorShop(createAdministratorShopRequest?: CreateAdministratorShopRequest, options?: AxiosRequestConfig) {
        return V1ApiFp(this.configuration).createAdministratorShop(createAdministratorShopRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary post draft shops
     * @param {CreateDraftShopRequest} [createDraftShopRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public createDraftShop(createDraftShopRequest?: CreateDraftShopRequest, options?: AxiosRequestConfig) {
        return V1ApiFp(this.configuration).createDraftShop(createDraftShopRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary owner sign up
     * @param {CreateOwnerRequest} [createOwnerRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public createOwner(createOwnerRequest?: CreateOwnerRequest, options?: AxiosRequestConfig) {
        return V1ApiFp(this.configuration).createOwner(createOwnerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary post shops
     * @param {CreateShopRequest} [createShopRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public createShop(createShopRequest?: CreateShopRequest, options?: AxiosRequestConfig) {
        return V1ApiFp(this.configuration).createShop(createShopRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary user sign up
     * @param {CreateUserRequest} [createUserRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public createUser(createUserRequest?: CreateUserRequest, options?: AxiosRequestConfig) {
        return V1ApiFp(this.configuration).createUser(createUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary DELETE cafe note
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public deleteCafeNote(id: number, options?: AxiosRequestConfig) {
        return V1ApiFp(this.configuration).deleteCafeNote(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get administrator draft shop
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getAdministratorDraftShop(id: number, options?: AxiosRequestConfig) {
        return V1ApiFp(this.configuration).getAdministratorDraftShop(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get administrator draft shops
     * @param {number} [page] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getAdministratorDraftShops(page?: number, options?: AxiosRequestConfig) {
        return V1ApiFp(this.configuration).getAdministratorDraftShops(page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary administrator session
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getAdministratorSession(options?: AxiosRequestConfig) {
        return V1ApiFp(this.configuration).getAdministratorSession(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get administrator shop
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getAdministratorShop(id: number, options?: AxiosRequestConfig) {
        return V1ApiFp(this.configuration).getAdministratorShop(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get administrator shops
     * @param {number} [page] 
     * @param {string} [area] 
     * @param {string} [shopName] 
     * @param {'morning' | 'lunch' | 'dinner'} [timeframe] 
     * @param {string} [upperBudget] 
     * @param {Array<string>} [featureIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getAdministratorShops(page?: number, area?: string, shopName?: string, timeframe?: 'morning' | 'lunch' | 'dinner', upperBudget?: string, featureIds?: Array<string>, options?: AxiosRequestConfig) {
        return V1ApiFp(this.configuration).getAdministratorShops(page, area, shopName, timeframe, upperBudget, featureIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get administrators features
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getAdministratorsFeatures(options?: AxiosRequestConfig) {
        return V1ApiFp(this.configuration).getAdministratorsFeatures(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get administrators payment methods
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getAdministratorsPaymentMethods(options?: AxiosRequestConfig) {
        return V1ApiFp(this.configuration).getAdministratorsPaymentMethods(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get administrators users
     * @param {number} [page] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getAdministratorsUsers(page?: number, options?: AxiosRequestConfig) {
        return V1ApiFp(this.configuration).getAdministratorsUsers(page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary GET cafe note
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getCafeNote(id: number, options?: AxiosRequestConfig) {
        return V1ApiFp(this.configuration).getCafeNote(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary GET cafe notes
     * @param {number} [page] 
     * @param {number} [per] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getCafeNotes(page?: number, per?: number, options?: AxiosRequestConfig) {
        return V1ApiFp(this.configuration).getCafeNotes(page, per, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get features
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getFeatures(options?: AxiosRequestConfig) {
        return V1ApiFp(this.configuration).getFeatures(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get payment methods
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getPaymentMethods(options?: AxiosRequestConfig) {
        return V1ApiFp(this.configuration).getPaymentMethods(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getProfile(options?: AxiosRequestConfig) {
        return V1ApiFp(this.configuration).getProfile(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get public cafe note
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getPublicCafeNote(id: number, options?: AxiosRequestConfig) {
        return V1ApiFp(this.configuration).getPublicCafeNote(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get public cafe note
     * @param {number} [page] 
     * @param {number} [per] 
     * @param {number} [shopId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getPublicCafeNotes(page?: number, per?: number, shopId?: number, options?: AxiosRequestConfig) {
        return V1ApiFp(this.configuration).getPublicCafeNotes(page, per, shopId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get public profile
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getPublicProfile(username: string, options?: AxiosRequestConfig) {
        return V1ApiFp(this.configuration).getPublicProfile(username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get public shop
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getPublicShop(id: number, options?: AxiosRequestConfig) {
        return V1ApiFp(this.configuration).getPublicShop(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get public shops
     * @param {number} [page] 
     * @param {number} [per] 
     * @param {string} [area] 
     * @param {string} [shopName] 
     * @param {'morning' | 'lunch' | 'dinner'} [timeframe] 
     * @param {string} [upperBudget] 
     * @param {Array<string>} [featureIds] 
     * @param {boolean} [favoriteFlag] 
     * @param {boolean} [visitFlag] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getPublicShops(page?: number, per?: number, area?: string, shopName?: string, timeframe?: 'morning' | 'lunch' | 'dinner', upperBudget?: string, featureIds?: Array<string>, favoriteFlag?: boolean, visitFlag?: boolean, options?: AxiosRequestConfig) {
        return V1ApiFp(this.configuration).getPublicShops(page, per, area, shopName, timeframe, upperBudget, featureIds, favoriteFlag, visitFlag, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get shop
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getShop(id: number, options?: AxiosRequestConfig) {
        return V1ApiFp(this.configuration).getShop(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get shops
     * @param {number} [page] 
     * @param {number} [userId] 
     * @param {number} [per] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getShops(page?: number, userId?: number, per?: number, options?: AxiosRequestConfig) {
        return V1ApiFp(this.configuration).getShops(page, userId, per, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary GET user request shop
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getUserRequestShop(id: number, options?: AxiosRequestConfig) {
        return V1ApiFp(this.configuration).getUserRequestShop(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary GET user request shops
     * @param {number} [page] 
     * @param {number} [per] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getUserRequestShops(page?: number, per?: number, options?: AxiosRequestConfig) {
        return V1ApiFp(this.configuration).getUserRequestShops(page, per, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary user session
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getUserSession(options?: AxiosRequestConfig) {
        return V1ApiFp(this.configuration).getUserSession(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary owner account activations
     * @param {UserActivatedRequest} [userActivatedRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public ownerActivated(userActivatedRequest?: UserActivatedRequest, options?: AxiosRequestConfig) {
        return V1ApiFp(this.configuration).ownerActivated(userActivatedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary owner login
     * @param {OwnerLoginRequest} [ownerLoginRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public ownerLogin(ownerLoginRequest?: OwnerLoginRequest, options?: AxiosRequestConfig) {
        return V1ApiFp(this.configuration).ownerLogin(ownerLoginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary post administrator draft shop approval
     * @param {PostAdministratorDraftShopApprovalRequest} [postAdministratorDraftShopApprovalRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public postAdministratorDraftShopApproval(postAdministratorDraftShopApprovalRequest?: PostAdministratorDraftShopApprovalRequest, options?: AxiosRequestConfig) {
        return V1ApiFp(this.configuration).postAdministratorDraftShopApproval(postAdministratorDraftShopApprovalRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary POST cafe note
     * @param {PostCafeNoteRequest} [postCafeNoteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public postCafeNote(postCafeNoteRequest?: PostCafeNoteRequest, options?: AxiosRequestConfig) {
        return V1ApiFp(this.configuration).postCafeNote(postCafeNoteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary post favorite
     * @param {PostFavoriteShopRequest} [postFavoriteShopRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public postFavoriteShop(postFavoriteShopRequest?: PostFavoriteShopRequest, options?: AxiosRequestConfig) {
        return V1ApiFp(this.configuration).postFavoriteShop(postFavoriteShopRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary put administrator shop
     * @param {number} id 
     * @param {PutAdministratorShopRequest} [putAdministratorShopRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public putAdministratorShop(id: number, putAdministratorShopRequest?: PutAdministratorShopRequest, options?: AxiosRequestConfig) {
        return V1ApiFp(this.configuration).putAdministratorShop(id, putAdministratorShopRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary put draft shop
     * @param {number} id 
     * @param {PutDraftShopRequest} [putDraftShopRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public putDraftShop(id: number, putDraftShopRequest?: PutDraftShopRequest, options?: AxiosRequestConfig) {
        return V1ApiFp(this.configuration).putDraftShop(id, putDraftShopRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary PATCH cafe note
     * @param {number} id 
     * @param {UpdateCafeNoteRequest} [updateCafeNoteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public updateCafeNote(id: number, updateCafeNoteRequest?: UpdateCafeNoteRequest, options?: AxiosRequestConfig) {
        return V1ApiFp(this.configuration).updateCafeNote(id, updateCafeNoteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update profile
     * @param {UpdateProfileRequest} [updateProfileRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public updateProfile(updateProfileRequest?: UpdateProfileRequest, options?: AxiosRequestConfig) {
        return V1ApiFp(this.configuration).updateProfile(updateProfileRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary user account activations
     * @param {UserActivatedRequest} [userActivatedRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public userActivated(userActivatedRequest?: UserActivatedRequest, options?: AxiosRequestConfig) {
        return V1ApiFp(this.configuration).userActivated(userActivatedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary user login
     * @param {UserLoginRequest} [userLoginRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public userLogin(userLoginRequest?: UserLoginRequest, options?: AxiosRequestConfig) {
        return V1ApiFp(this.configuration).userLogin(userLoginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary user logout
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public userLogout(options?: AxiosRequestConfig) {
        return V1ApiFp(this.configuration).userLogout(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary user password reset
     * @param {UserPasswordResetRequest} [userPasswordResetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public userPasswordReset(userPasswordResetRequest?: UserPasswordResetRequest, options?: AxiosRequestConfig) {
        return V1ApiFp(this.configuration).userPasswordReset(userPasswordResetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary user password reset reception
     * @param {UserPasswordResetReceptionRequest} [userPasswordResetReceptionRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public userPasswordResetReception(userPasswordResetReceptionRequest?: UserPasswordResetReceptionRequest, options?: AxiosRequestConfig) {
        return V1ApiFp(this.configuration).userPasswordResetReception(userPasswordResetReceptionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


